import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * When an assignAccess request is made, attempts to execute the API request,
 * and send out the appropriate success or error action afterwards
 */
export const assignAccessOnRequest = store.effects.create((feature: Feature) =>
  feature.actions.assignAccess.request.observe().pipe(
    rxjs.mergeMap(action =>
      feature.api.assignAccess(action.data.assignments).pipe(
        // Handles success
        rxjs.map(() =>
          feature.actions.assignAccess.success.from(action).create({
            request: action.data,
          }),
        ),
        // Handles error
        rxjs.catchError(error =>
          rxjs.of(
            feature.actions.assignAccess.error.from(action).create({
              error,
              request: action.data,
            }),
          ),
        ),
      ),
    ),
  ),
)
